var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 16,
    viewBox: "0 0 61 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6111 0.20933H28.801V10.0478C28.801 13.3762 26.266 15.5742 22.4634 15.5742C18.6609 15.5742 16.147 13.3762 16.147 10.0478V0.20933H19.3158V9.79665C19.3158 11.5341 20.5622 12.811 22.4634 12.811C24.3858 12.811 25.6111 11.5341 25.6111 9.79665V0.20933Z",
    fill: "#4A25A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1379 0.20933V15.3648H41.3917L34.6738 5.73565H34.5471V15.3648H31.3783V0.20933H34.1668L40.8424 9.83852H40.9903V0.20933H44.1379Z",
    fill: "#4A25A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8765 5.08672C56.454 3.66328 55.2921 2.78409 53.6232 2.78409C51.2571 2.78409 49.6516 4.58433 49.6516 7.76615C49.6516 10.9689 51.2149 12.7901 53.6443 12.7901C55.8308 12.7901 57.13 11.5655 57.1722 9.65012H53.8556V7.28469H60.2354V9.16866C60.2354 13.1459 57.4891 15.5742 53.6232 15.5742C49.3348 15.5742 46.4195 12.6017 46.4195 7.80801C46.4195 2.88876 49.5249 0 53.5598 0C57.0032 0 59.665 2.0933 60.0875 5.08672H56.8765Z",
    fill: "#4A25A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15581 0L0.0825424 7.898H1.61056L0 16L6.33516 6.58373H5.03896L6.1801 2.36696L8.80742 2.37321H8.79844H8.83806C10.0114 2.37321 10.9627 3.31576 10.9627 4.47847C10.9627 5.50961 10.2145 6.36761 9.22677 6.54858L9.11646 6.56582C9.02535 6.57764 8.93242 6.58373 8.83806 6.58373H8.75036V8.88038L9.14951 8.91554C10.1373 9.0965 10.8854 9.9545 10.8854 10.9856C10.8854 12.1484 9.93418 13.0909 8.7608 13.0909H7.3199L5.69626 15.4641H9.33403C11.8186 15.4641 13.8327 13.4683 13.8327 11.0063C13.8327 9.71196 13.276 8.54643 12.3868 7.73205C13.276 6.91767 13.8327 5.75214 13.8327 4.45777C13.8327 1.99581 11.8186 0 9.334 0H2.15581Z",
    fill: "#4A25A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBung);
export default __webpack_public_path__ + "static/media/bung.3b5ffb0d048d9ff51dccf3c7bbf1c5f5.svg";
export { ForwardRef as ReactComponent };